// Spanish prices use a comma: 14,00 €. English keeps the dot.
export const formatPrice = (value, lang = "es") =>
  `${Number(value).toFixed(2).replace(".", lang === "es" ? "," : ".")} €`;

export const isAvailable = (product) => product?.available !== false;
